import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getImpersonation, stopImpersonation } from "@/lib/impersonation";

/** Persistent "viewing as central" banner (roadmap 2.4). */
export function ImpersonationBanner() {
  const { t } = useTranslation();
  const [state] = useState(getImpersonation);
  const [exiting, setExiting] = useState(false);

  if (!state) return null;

  async function handleExit() {
    setExiting(true);
    await stopImpersonation();
    // Full reload so every auth-dependent piece of state re-initialises as admin.
    window.location.assign("/admin");
  }

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-amber px-4 py-2 text-[12.5px] font-bold text-navy"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
      <span>{t("impersonation.viewingAs", { name: state.central_name })}</span>
      <button
        type="button"
        onClick={() => void handleExit()}
        disabled={exiting}
        className="rounded-md border border-navy/30 bg-white/40 px-2.5 py-0.5 text-[11.5px] font-extrabold hover:bg-white/70 disabled:opacity-60"
      >
        {exiting ? t("common.loading") : t("impersonation.exit")}
      </button>
    </div>
  );
}
